var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"pagination"},[_vm._t("buttons",function(){return _vm._l((_vm.buttons),function(button,key){return _c('page-button',_vm._b({key:key,on:{"page-change":function($event){return _vm.$emit('page-change', button.page)}}},'page-button',button,false))})},{"buttons":_vm.buttons})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }